@defer (when !isLoading()) {
  @if (privateRecipientDetails?.length > 0 || companies?.length > 0) {
    <div class="tables-wrapper">
      <!-- PHONE NUMBERS -->
      <bi-address-info-table
        *ngIf="phoneRecipientsDetails?.length > 0"
        [recipientsDetails]="phoneRecipientsDetails"
        contactDetailIconClass="fa-solid fa-mobile-alt"
        [isStatus]="this.dialogInputData.isStatus"
        [useColumnWidthLimits]="alignTables()"
        recipientType="phone"
        @fadeIn
      />

      <!-- EMAILS -->
      <bi-address-info-table
        *ngIf="emailRecipientsDetails?.length > 0"
        [recipientsDetails]="emailRecipientsDetails"
        contactDetailIconClass="fa-regular fa-envelope"
        [isStatus]="this.dialogInputData.isStatus"
        [useColumnWidthLimits]="alignTables()"
        recipientType="email"
        @fadeIn
      />

      <!-- E-BOKS -->
      <bi-address-info-table
        *ngIf="eboksRecipientsDetails?.length > 0"
        [recipientsDetails]="eboksRecipientsDetails"
        [isStatus]="this.dialogInputData.isStatus"
        recipientType="eboks"
        [useColumnWidthLimits]="alignTables()"
        @fadeIn
      />

      <!-- COMPANIES -->
      <bi-address-info-table *ngIf="companies?.length > 0" [recipientsDetails]="companies" recipientType="company" [useColumnWidthLimits]="alignTables()" @fadeIn />
    </div>
  } @else {
    <!-- No info -->
    <p class="text-center" translate>shared.NoInfoFound</p>
  }

  <div class="text-center mt-4" @fadeIn *ngIf="dialogInputData.enableDeselection != undefined ? this.dialogInputData.enableDeselection : true">
    <!-- Deselect button and OK/cancel -->
    @if (!showAreYouSureToDeselect()) {
      <p-button type="button" severity="info" [label]="'messages.DeselectAddress' | translate" (click)="showAreYouSureToDeselect.set(true)" />
    } @else {
      <div @fadeIn>
        <h4 class="text-center" translate>messages.ShouldAddressBeDeselected</h4>
        <div class="flex justify-content-center w-full gap-2 bi-p-fluid">
          <!-- Delete -->
          <p-button type="button" severity="info" class="w-6 sm:w-4" [label]="'shared.Yes' | translate" (click)="onDeleteAddressClicked()" />

          <!-- Cancel -->
          <p-button type="button" severity="secondary" class="w-6 sm:w-4" [label]="'shared.Cancel' | translate" (click)="showAreYouSureToDeselect.set(false)" />
        </div>
      </div>
    }
  </div>
} @placeholder {
  <bi-spinner [centerInParent]="true" @fadeIn />
}
